import { crossdockReceiptActions } from '../crossdockReceipt.state';
const tryRevokeReceiptItem = (item) => (dispatch) => {
    if (item.receiptedQuantity === 0)
        return;
    const revokeItemData = { invoiceId: item.invoiceId, receiptItemId: item.receiptItemId, isBlocked: false };
    dispatch(crossdockReceiptActions.openRevokeReceiptItemDialog(revokeItemData));
};
export { tryRevokeReceiptItem };
